import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MenuComponent } from '../../shared/Components/menu/menu.component';
import { FooterComponent } from '../../shared/Components/footer/footer.component';
import { LoadingSpinnerService } from '../../shared/services/loading-spinner-service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UserActivityService } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'debtor-panel-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [
    TranslateModule,
    StoreModule,
    CommonModule,
    RouterModule,
    MenuComponent,
    FooterComponent,
    MatProgressSpinnerModule,
  ],
})
export class DashboardComponent {
  protected spinnerService = inject(LoadingSpinnerService);
  private userActivityService = inject(UserActivityService);
  private keycloack = inject(Keycloak);
  private router = inject (Router);


  constructor() {
    this.userActivityService.startMonitoring();
    this.checkIfUserActive();
  }

  private checkIfUserActive() {
    setTimeout(() => {
      if(this.userActivityService.isActive(300000)) {
        this.checkIfUserActive();
      }
      else {
        this.keycloack.logout();
      }
    }, 60000);
  }

  protected navigateToOrderContact(): void {
    this.router.navigate(['/order-contact']);
  }
}